import { ToolkitPageLayout } from 'toolkit/components/ToolkitPageLayout'
// import { champions_presentations, FosteringRelationshipsPdf } from 'assets' // FosteringRelationshipsPdf commented out
import { champions_presentations } from 'assets'

const presentationLinks = [
  {
    href: 'https://docs.google.com/presentation/d/e/2PACX-1vSsAcRKwiO-HCDLIagJWYsQRolNkPnMbXuyxfVuk7uYuns2kaHUf8-KQeRWJFiJNA/pub?start=false&loop=false&delayms=3000',
    imgSrc: champions_presentations,
    altText: 'Sickle Cell Champions Presentation Screenshot',
    caption: 'Sickle Cell Champions'
  },
  {
    href: 'https://docs.google.com/presentation/d/e/2PACX-1vRyjrEhTGcHvTAli_B1MpyIubFbTvJNUqFC02zLE2jFTi7AO5RTDoxMx8BK08Cauw/pub?start=false&loop=false&delayms=3000',
    imgSrc: champions_presentations,
    altText: 'Building Engagement and Buy-In Presentation Screenshot',
    caption: 'Building Engagement and Buy-In'
  }
]

const pdfInfo = {
  url: 'invalid-pdf-link.pdf', // TODO: Replace with actual path to FosteringRelationshipsPdf once added to assets
  title: 'Fostering Relationships Infusion Clinic and ER',
  downloadName: 'Fostering_Relationships_Infusion_Clinic_ER.pdf'
}

const youtubeVideoId = 'wc51GI_gju0'
const youtubeVideoCaption = "Understanding Sickle Cell Patients' Pain in the ER"

export const InstitutionChampionsPage: React.FC = () => {
  const breadcrumbs = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Institution', path: '/toolkit/institution' },
    {
      label: 'SCD Team & ED Relationship',
      path: '/toolkit/institution/scd-team-ed-relationship'
    },
    { label: 'Champions', path: '/toolkit/institution/champions' }
  ]

  return (
    <ToolkitPageLayout title="Champions" breadcrumbs={breadcrumbs}>
      <div className="container mx-auto px-4 py-8 prose prose-lg max-w-4xl">
        <p className="lead text-center mb-12">
          Building a strong network of champions within your institution is key
          to improving care for individuals with Sickle Cell Disease. These
          resources provide insights and strategies for engaging stakeholders
          and fostering productive relationships, particularly between the SCD
          team and the Emergency Department.
        </p>

        <h2 className="text-2xl font-semibold text-[#142841] mb-6">
          Presentations
        </h2>
        <div className="grid md:grid-cols-2 gap-8 mb-12 not-prose">
          {presentationLinks.map((link, index) => (
            <a
              key={index}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-200"
            >
              <img
                src={link.imgSrc}
                alt={link.altText}
                className="w-full h-56 object-contain rounded-md mb-4 bg-gray-100 p-2"
              />
              <figcaption className="text-center text-md font-medium text-[#3C2416]">
                {link.caption}
              </figcaption>
            </a>
          ))}
        </div>

        <hr className="my-12" />

        <h2 className="text-2xl font-semibold text-[#142841] mb-6">
          Key Document: Fostering Relationships
        </h2>
        <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 mb-12 not-prose">
          <h3 className="text-xl font-medium text-[#3C2416] mb-3">
            {pdfInfo.title}
          </h3>
          <p className="mb-4 text-gray-700">
            This document provides valuable insights into building and
            maintaining effective communication and collaboration between the
            infusion clinic and the emergency department.
          </p>
          <object
            data={pdfInfo.url}
            type="application/pdf"
            width="100%"
            height="500px"
            className="mt-6 rounded shadow"
          >
            <p className="text-center text-gray-600">
              Your browser does not support PDFs. Please download the PDF to
              view it:{' '}
              <a
                href={pdfInfo.url}
                download={pdfInfo.downloadName}
                className="text-[#142841] hover:text-[#A6410A] underline"
              >
                Download PDF
              </a>
              .
            </p>
          </object>
          {/* "View PDF" and "Download PDF" buttons (opens in new tab) centered below object */}
          <div className="mt-4 flex flex-col sm:flex-row justify-center items-center gap-4">
            <a
              href={pdfInfo.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#A6410A] text-white px-6 py-2 rounded-md hover:bg-[#C25F0C] transition-colors"
            >
              View PDF
            </a>
            <a
              href={pdfInfo.url}
              download={pdfInfo.downloadName}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#142841] text-white font-medium px-5 py-2.5 rounded-md hover:bg-[#0F1E30] transition-colors duration-300 text-sm"
            >
              Download PDF
            </a>
          </div>
        </div>

        <hr className="my-12" />

        <h2 className="text-2xl font-semibold text-[#142841] mb-6">
          Video Resource
        </h2>
        <div className="mb-12 not-prose">
          <div className="aspect-w-16 aspect-h-9 h-[50vh] w-[50vw] auto-mx max-w-3xl mx-auto bg-black rounded-lg shadow-lg overflow-hidden">
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${youtubeVideoId}`}
              title={youtubeVideoCaption}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <p className="mt-3 text-center text-md font-medium text-gray-700">
            {youtubeVideoCaption}
          </p>
        </div>

        <div className="mt-16 text-center not-prose">
          <a
            href="/toolkit/institution/scd-team-ed-relationship"
            className="inline-block bg-[#A6410A] text-white font-semibold px-8 py-3 rounded-lg shadow-md hover:bg-[#C25F0C] transition-colors duration-300"
          >
            All done? Back to SCD Team & ED Relationship
          </a>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
